<template>
  <div class="over-page" @click.self="close">
    <main>
      <div class="frame mid">
        <div class="modal-content-wrapper">
          <header class="page-title">
            <h3>Nova Forma de Pagamento</h3>
            <router-link target="_blank" :to="{name:'forma-pagamento'}" class="btn btn-secondary">Ver todos</router-link>
          </header>

          <div class="modal-body">
            <div class="form-group">
              <input-control
                required
                id="nome"
                label="Nome"
                placeholder="Pagamento à vista"
                v-model="form.nome"
              />
            </div>

            <div class="d-flex align-center mb-4">
              <switch-control v-model:checked="hasEntrada" labelOn="Forma de pagamento com entrada" labelOff="Forma de pagamento sem entrada" invert></switch-control>
            </div>

            <div class="tabs-panel">
              <nav class="tabs-navs">
                <a
                  href="#"
                  @click.prevent="activeTab = 'entrada'"
                  :class="['tabs-nav', { active: activeTab === 'entrada' }]"
                  v-if="hasEntrada"
                >
                  <span>Entrada</span>
                </a>

                <a
                  href="#"
                  @click.prevent="activeTab = 'parcelas'"
                  :class="['tabs-nav', { active: activeTab === 'parcelas' }]"
                >
                  <span>Parcelas</span>
                </a>

                <a
                  href="#"
                  @click.prevent="activeTab = 'descontos'"
                  :class="['tabs-nav', { active: activeTab === 'descontos' }]"
                >
                  <span>Descontos</span>
                </a>
              </nav>
              <div class="tabs-controller">
                <div v-if="activeTab === 'entrada' && hasEntrada">
                  <!-- Cartão -->
                  <section class="method-card">
                    <div class="method-header row">
                      <div class="col-md-4 form-group">
                        <input-control label="PAR Código" placeholder="Par Código" v-model="form.entrada.PARCodigo"/>
                      </div>
                    </div>
                  </section>

                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Cartão" labelOff="Cartão" v-model:checked="form.entrada.cartao.ativo" />
                    </div>

                    <div
                      v-if="form.entrada.cartao.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.cartao.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.entrada.cartao.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.cartao.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.cartao.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Boleto -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Boleto" labelOff="Boleto" v-model:checked="form.entrada.boleto.ativo" />
                    </div>

                    <div
                      v-if="form.entrada.boleto.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.boleto.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.entrada.boleto.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.boleto.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.boleto.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Pix -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Pix" labelOff="Pix" v-model:checked="form.entrada.pix.ativo" />
                    </div>

                    <div
                      v-if="form.entrada.pix.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.pix.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.pix.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.pix.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>
                </div>

                <div v-else-if="activeTab === 'parcelas'">
                  <section class="method-card">
                    <div class="method-header row">
                      <div class="col-md-4">
                        <input-control label="PAR Código" placeholder="Par Código" v-model:checked="form.parcelas.PARCodigo"/>
                      </div>
                    </div>
                  </section>
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Cartão" labelOff="Cartão" v-model:checked="form.parcelas.cartao.ativo" />
                    </div>

                    <div
                      v-if="form.parcelas.cartao.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.parcelas.cartao.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.parcelas.cartao.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.cartao.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Boleto -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Boleto" labelOff="Boleto" v-model:checked="form.parcelas.boleto.ativo" />
                    </div>
                    <div
                      v-if="form.parcelas.boleto.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.parcelas.boleto.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.parcelas.boleto.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.boleto.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Pix -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Pix" labelOff="Pix" v-model:checked="form.parcelas.pix.ativo" />
                    </div>

                    <div
                      v-if="form.parcelas.pix.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          v-model="form.parcelas.pix.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.pix.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>
                </div>

                <div v-else>
                  <section>
                    <article class="method-card row g-16 descontos">
                      <div class="col-md-3 form-group">
                        <input-control label="Deconto Principal (%)" placeholder="20" v-model="form.descontoPrincipal"/>
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control label="Deconto Multa (%)" placeholder="10" v-model="form.descontoMulta"/>
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control label="Deconto Juros (%)" placeholder="10" v-model="form.descontoJuros"/>
                      </div>
                    </article>
                  </section>
                </div>
              </div>
            </div>
          </div>
          <footer>
            <button class="btn btn-secondary" @click="close">Voltar</button>
            <button class="btn btn-primary" @click="salvar">Salvar</button>
          </footer>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import negociejaService from '@/services/negocieja.service.js';

export default {
  name: 'NovoPagamento',
  emits: ['fechar'],
  data() {
    return {
      activeTab: 'entrada',
      hasEntrada: false,
      form: {
        nome: '',
        descontoPrincipal: 0,
        descontoMulta: 0,
        descontoJuros: 0,
        // PARCodigo: '',
        entrada: {
          PARCodigo: '',
          cartao: {
            ativo: false,
            percentualMinimo: '',
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: '',
          },
          boleto: {
            ativo: false,
            percentualMinimo: '',
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: '',
          },
          pix: {
            ativo: false,
            percentualMinimo: '',
            competenciaInicial: '',
            diaVencimento: '',
          }
        },
        parcelas: {
          PARCodigo: '',
          cartao: {
            ativo: false,
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: ''
          },
          boleto: {
            ativo: false,
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: ''
          },
          pix: {
            ativo: false,
            competenciaInicial: '',
            diaVencimento: ''
          }
        }
      }
    };
  },
  methods: {
    close() {
      this.$emit('fechar');
    },
    abrirLista() {
      console.log('Abrir lista de formas de pagamento existentes');
    },
    salvar() {
      const payload = {
        nome: this.form.nome,
        descontoPrincipal: this.form.descontoPrincipal,
        descontoMulta: this.form.descontoMulta,
        descontoJuros: this.form.descontoJuros,
        entrada: {
          PARCodigo: this.form.entrada.PARCodigo,
          cartao: {
            ativo: this.form.entrada.cartao.ativo ? 1 : 0,
            percentualMinimo: this.form.entrada.cartao.percentualMinimo,
            maximoParcelas: this.form.entrada.cartao.maximoParcelas,
            competenciaInicial: this.form.entrada.cartao.competenciaInicial,
            diaVencimento: this.form.entrada.cartao.diaVencimento
          },
          boleto: {
            ativo: this.form.entrada.boleto.ativo ? 1 : 0,
            percentualMinimo: this.form.entrada.boleto.percentualMinimo,
            maximoParcelas: this.form.entrada.boleto.maximoParcelas,
            competenciaInicial: this.form.entrada.boleto.competenciaInicial,
            diaVencimento: this.form.entrada.boleto.diaVencimento
          },
          pix: {
            ativo: this.form.entrada.pix.ativo ? 1 : 0,
            percentualMinimo: this.form.entrada.pix.percentualMinimo,
            competenciaInicial: this.form.entrada.pix.competenciaInicial,
            diaVencimento: this.form.entrada.pix.diaVencimento
          }
        }, 
        parcelas: {
          PARCodigo: this.form.parcelas.PARCodigo,
          cartao: {
            maximoParcelas: this.form.parcelas.cartao.maximoParcelas,
            competenciaInicial: this.form.parcelas.cartao.competenciaInicial,
            diaVencimento: this.form.parcelas.cartao.diaVencimento
          },
          boleto: {
            ativo: this.form.parcelas.boleto.ativo ? 1 : 0,
            maximoParcelas: this.form.parcelas.boleto.maximoParcelas,
            competenciaInicial: this.form.parcelas.boleto.competenciaInicial,
            diaVencimento: this.form.parcelas.boleto.diaVencimento
          },
          pix: {
            ativo: this.form.parcelas.pix.ativo ? 1 : 0,
            competenciaInicial: this.form.parcelas.pix.competenciaInicial,
            diaVencimento: this.form.parcelas.pix.diaVencimento
          }
        }
      }

      console.log("salvar:", payload)

      negociejaService.createPagamentos(payload)
        .then(() => {
          this.close();
        })
        .catch((err) => {
          console.error('Erro ao salvar forma de pagamento:', err)
        })
    }
  }
};
</script>

<style lang="scss" scoped>

.descontos{
  padding-top: -1px;
  padding: 2rem;
}


.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: $border-component;
  padding: $mg_small;
  h3 {
    color: $vermelho;
    margin: 0;
    // line-height: 1;
  }
}

.modal {
    padding: 0 !important;
}

.modal-content-wrapper {
  margin-top: 2rem;
  margin-bottom: 2rem;
  background: $branco;
  border-radius: $border-radius;
  border: $border-component;
  max-height: auto;
  display: flex;
  flex-direction: column;
}

footer {
  border-top: $border-component;
  padding: $mg_small;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $branco;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

.tabs-panel {
  margin: 0 !important;
  .tabs-navs {
    margin: 0px !important;
    padding: 0 !important;
    display: flex;
    padding-bottom: $mg_small;
  }
  .tabs-nav {
    gap: 0px !important;
    border: 1px solid $border-component;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-radius: $border-radius-small;
    font-size: $font-size-small;
    color: $color-text;
    background: $color-secondary;
    cursor: pointer;
    text-decoration: none;
    &.active {
      border-color: $vermelho;
      // background: $vermelho;
      // color: $branco;
    }
    &:hover:not(.active) {
      border-color: $color-primary;
      color: $color-primary;
    }
  }
}

.method-card {
  margin: 0 !important;
  border-top: $border-component;
  // border-radius: $border-radius-small;
  margin-bottom: $mg;

  &:first-of-type {
    border-top: 0 !important
  }
  .method-header {
    display: flex;
    align-items: center;
    padding: $mg_mini $hmg_small;
    border-top: -1px ;
    h5 { margin: 0; }
  }
  .method-fields { padding: $mg_small $hmg_small; }
}
</style>
